import { deriveTimezoneFromZip } from './timezone-from-zip';

/**
 * Business hours check — matches leads-hub IsWithinBusinessHours.
 * Business hours: daily 8 AM – 8:59 PM in the lead's zip-derived timezone.
 */

const BUSINESS_HOUR_START = 8;
const BUSINESS_HOUR_END = 21;

const getLocalHourInTimezone = (date: Date, timezone: string): number => {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: timezone,
    hour: 'numeric',
    hour12: false,
  }).formatToParts(date);

  const hourPart = parts.find((part) => part.type === 'hour');
  return parseInt(hourPart?.value ?? '0', 10);
};

/**
 * Returns true if the given moment is within business hours (8am–8:59pm daily)
 * in the specified IANA timezone.
 */
export const isDuringBusinessHours = (date: Date, timezone: string): boolean => {
  const hour = getLocalHourInTimezone(date, timezone);
  return hour >= BUSINESS_HOUR_START && hour < BUSINESS_HOUR_END;
};

/**
 * Returns true if the lead (by zip) is currently outside business hours.
 */
export const isAfterHoursForZip = (zipCode: string, date: Date = new Date()): boolean => {
  const timezone = deriveTimezoneFromZip(zipCode);
  return !isDuringBusinessHours(date, timezone);
};
